import {createSlice} from "@reduxjs/toolkit";

export const dashboardSlice = createSlice({
    name: "dashboardDetails",
    initialState: {
        dashboardDataByprojId: {},
    },
    reducers: {
        setDashboardDataByprojId(state, action){
            state.dashboardDataByprojId = action.payload;
        },
    }
})

export const {setDashboardDataByprojId} = dashboardSlice.actions;